import { AsyncPipe } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { ActivatedRoute, Router } from "@angular/router";
import { LoaderComponent } from "src/app/components/global/loader/loader.component";
import { ErrorMessageComponent } from "src/app/components/global/snackbar/impl/error-message/error-message.component";
import { SnackbarService } from "src/app/components/global/snackbar/snackbar.service";
import { ROUTES_CONFIG } from "src/config/routes.config";
import { ApplicationService } from "src/services/application.service";
import { HttpService } from "src/services/http.service";
import { ContentResponse, ContentScreenComponent, FFWDContent } from "../../secure/content/content.component";

@Component({
  selector: "app-unsecure-content",
  imports: [ContentScreenComponent, AsyncPipe, MatIconModule, LoaderComponent],
  templateUrl: "./unsecure-content.component.html",
  styleUrl: "./unsecure-content.component.less",
})
export class UnsecureContentComponent implements OnInit {
  private http = inject(HttpService);
  private router = inject(Router);
  private route = inject(ActivatedRoute)
    .snapshot.url.map((f) => f.path)
    .join("/");
  private snackbar = inject(SnackbarService);
  public application = inject(ApplicationService);

  public content: FFWDContent | null;
  public contentPostUrl: string;

  public constructor() {
    this.content = null;
    this.contentPostUrl = ROUTES_CONFIG.joinUrl;
  }

  public async ngOnInit(): Promise<void> {
    try {
      this.application.loading.next(true);
      const response = await this.http.retrieve<ContentResponse>(`${ROUTES_CONFIG.unsecureContenturl}/${this.route}`, undefined, {
        bypassErrorHandling: true,
      });
      const content = JSON.parse(response[0].content);
      if ("content" in content) this.content = content;
    } catch (error) {
      console.error("Error while getting content =>", error);
    } finally {
      this.application.loading.next(false);
    }

    if (!this.content) {
      this.snackbar.open<string>(ErrorMessageComponent, "ERRORS.RESPONSE");
      this.router.navigate(["/"]);
    }
  }
}
